import { render, staticRenderFns } from "./UserInfoView.vue?vue&type=template&id=2f686e22&"
import script from "./UserInfoView.vue?vue&type=script&lang=js&"
export * from "./UserInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports